/**
 * Firebase App Compatibility Module
 * This file provides a direct compatibility module for 'firebase/compat/app'
 * to ensure that any code or dependencies that import this module can function properly.
 */

import firebase from './firebase-compat-shim';
export default firebase;
